// extracted by mini-css-extract-plugin
module.exports = {"container":"FAQCard_container__1Ei5V","answer":"FAQCard_answer__3-7tF","question":"FAQCard_question__3a_rG","title":"FAQCard_title__3XC11","active":"FAQCard_active__2r6bD"};